import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../../../../../../../../common/services/api.service";
import {Modal, ModalService} from "../../../../../../../services/modal.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {StorageService} from "../../../../../../../../common/services/storage.service";
// Do NOT short this import statement!!!
// noinspection TypeScriptPreferShortImport
import {PusherService} from "../../../../../../../../common/services/pusher.service";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {PartnerPartMasterService} from "../../../../../services/part-master.service";
import {Wizard} from "../../../../../../../../common/interfaces/wizard.interface";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {OrderWizardItemsTransferComponent} from "../transfer/items.component";
import {OrderWizardItemRmaComponent} from "../../item/rma/item.component";
import {OrderWizardItemKittingComponent} from "../../item/kitting/item.component";

@Component({
    selector: "section-order-wizard-items-kitting",
    templateUrl: "../items.component.html",
    styleUrls: [
        "../items.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class OrderWizardItemsKittingComponent extends OrderWizardItemsTransferComponent implements OnChanges {

    public constructor(
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected modalService: ModalService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected toastService: ToastService,
        protected storageService: StorageService,
        protected pusherService: PusherService,
        protected partMasterService: PartnerPartMasterService,
        protected spinnerService: SpinnerService
    ) {
        super(apiService, api3Service, modalService, changeDetectorRef, toastService,
            storageService, pusherService, partMasterService, spinnerService);
    }

    protected setup(data: Wizard.IData): void {
        super.setup(data);

        this.prepareOutboundTable();
        this.prepareInboundTable();
    }


    /**
     * Add new item
     * @returns {void}
     */
    public async addItem(type: any = null): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(OrderWizardItemKittingComponent, {
            partmasters: this.partmasters,
            details: this.details,
            order_id: this.data.order_id,
            serviceLevel: this.serviceLevel,
            state: this.state,
            modalWidth: type === "inbound" ? "600px" : "95%",
            modalHeight: type === "inbound" ? "auto" : "90%",
            hubs_from: this.data.hubs_from,
            hubs_to: this.data.hubs_to,
            type: type
        });
        if (response && response.value) {

            this.outboundTableRef.reload(this.getUrl("outbound"));
            this.inboundTableRef.reload(this.getUrl("inbound"));

            this._skipAllocations = false;
            this.changeDetectorRef.markForCheck();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

}
